import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = {
  reservationId: number;
};

type Response = {
  url: string;
};

// Mints the customer-facing sign-and-pay URL for a pending reservation:
// {orion_url}/trips/{id}/contract-sign?public_token={token}
export const useSignLink = createMutation<Response, Variables, AxiosError>({
  mutationFn: async ({ reservationId }) =>
    client
      .post(`v2/internal/partners/reservations/${reservationId}/sign-link`)
      .then((response) => response.data.data),
});
